import type { ConquestsArea, HubSection } from "./types";

const CONQUESTS_AREA_QUERY: Readonly<Record<ConquestsArea, string>> = {
  now: "agora",
  earn: "ganhar",
  compete: "competir",
  profile: "perfil",
};

const QUERY_AREA: ReadonlyMap<string | null, ConquestsArea> = new Map([
  ["ganhar", "earn"],
  ["competir", "compete"],
  ["perfil", "profile"],
]);

export function isConquestsArea(value: string | null): value is ConquestsArea {
  return (
    value === "now" ||
    value === "earn" ||
    value === "compete" ||
    value === "profile"
  );
}

export function areaFromLegacySection(value: string | null): ConquestsArea {
  const canonical = QUERY_AREA.get(value);
  if (canonical) return canonical;
  if (isConquestsArea(value)) return value;
  if (value === "ranking") return "compete";
  if (EARN_SECTIONS.includes(value as HubSection)) return "earn";
  if (PROFILE_SECTIONS.includes(value as HubSection)) return "profile";
  return "now";
}

export function conquestsAreaQueryValue(area: ConquestsArea): string {
  return CONQUESTS_AREA_QUERY[area];
}

export function areaFromDestination(destination: string): ConquestsArea {
  // #242 C1b: o CTA de cashback chega ancorado
  // ("/gamification/history#conquests-profile-history") — o hash não pode
  // grudar no pathname, senão o destino degrada pro fallback "now".
  const withoutHash = destination.split("#", 1)[0] ?? destination;
  const [pathname, search] = withoutHash.split("?", 2);
  if (pathname === "/ranking") return "compete";
  if (pathname === "/gamification/history") return "profile";
  return areaFromLegacySection(new URLSearchParams(search).get("section"));
}

// #232: "referral" saiu daqui junto com o painel de indicação do hub (17/07) —
// o deep-link legado ?section=referral cai no fallback padrão ("now").
const EARN_SECTIONS: readonly HubSection[] = [
  "missions",
  "store",
  "rewards",
  "season",
];

const PROFILE_SECTIONS: readonly HubSection[] = ["benefits", "achievements"];
